"use client";

const KEYS = {
  CLIENT_SECRET: "paymentClientSecret",
  PAYMENT_METHOD_ID: "paymentMethodId",
  PAYMENT_INTENT_ID: "paymentIntentId",
  PAYMENT_EMAIL: "paymentEmail",
  SUBSCRIPTION_ID: "subscriptionId",
  PAYMENT_COMPLETED: "payment_completed",
  LAST_PURCHASED_CONTENT: "last_purchased_content",
};

export const savePaymentData = (data: {
  clientSecret?: string;
  paymentMethodId?: string;
  paymentIntentId?: string;
  paymentEmail?: string;
  subscriptionId?: string;
}) => {
  if (typeof window === "undefined") return;

  if (data.clientSecret) {
    window.localStorage.setItem(KEYS.CLIENT_SECRET, data.clientSecret);
  }
  if (data.paymentMethodId) {
    window.localStorage.setItem(KEYS.PAYMENT_METHOD_ID, data.paymentMethodId);
  }
  if (data.paymentIntentId) {
    window.localStorage.setItem(KEYS.PAYMENT_INTENT_ID, data.paymentIntentId);
  }
  if (data.paymentEmail) {
    window.localStorage.setItem(KEYS.PAYMENT_EMAIL, data.paymentEmail);
  }
  if (data.subscriptionId) {
    window.localStorage.setItem(KEYS.SUBSCRIPTION_ID, data.subscriptionId);
  }
};

export const setPaymentCompleted = (contentId: string) => {
  if (typeof window === "undefined") return;

  window.localStorage.setItem(KEYS.PAYMENT_COMPLETED, "true");
  window.localStorage.setItem(KEYS.LAST_PURCHASED_CONTENT, contentId);
};

export const getPaymentData = () => {
  if (typeof window === "undefined") {
    return {
      clientSecret: null,
      paymentMethodId: null,
      paymentIntentId: null,
      paymentEmail: null,
      subscriptionId: null,
      paymentCompleted: false,
      lastPurchasedContent: null,
    };
  }

  return {
    clientSecret: window.localStorage.getItem(KEYS.CLIENT_SECRET),
    paymentMethodId: window.localStorage.getItem(KEYS.PAYMENT_METHOD_ID),
    paymentIntentId: window.localStorage.getItem(KEYS.PAYMENT_INTENT_ID),
    paymentEmail: window.localStorage.getItem(KEYS.PAYMENT_EMAIL),
    subscriptionId: window.localStorage.getItem(KEYS.SUBSCRIPTION_ID),
    paymentCompleted:
      window.localStorage.getItem(KEYS.PAYMENT_COMPLETED) === "true",
    lastPurchasedContent: window.localStorage.getItem(
      KEYS.LAST_PURCHASED_CONTENT
    ),
  };
};

export const clearPaymentStorage = (
  setLocalPaymentIntentId?: (id: null) => void,
  preservePaymentCompleted: boolean = false
): void => {
  console.log("Clearing payment data from localStorage");
  if (typeof window === "undefined") return;

  window.localStorage.removeItem(KEYS.CLIENT_SECRET);
  window.localStorage.removeItem(KEYS.PAYMENT_METHOD_ID);
  window.localStorage.removeItem(KEYS.PAYMENT_INTENT_ID);
  window.localStorage.removeItem(KEYS.PAYMENT_EMAIL);
  window.localStorage.removeItem(KEYS.SUBSCRIPTION_ID);

  if (
    window.location.href.includes("/checkout/") &&
    !preservePaymentCompleted
  ) {
    console.log("Clearing payment_completed flag");
    window.localStorage.removeItem(KEYS.PAYMENT_COMPLETED);
  }

  const url = new URL(window.location.href);
  if (
    url.searchParams.has("payment_intent_id") ||
    url.searchParams.has("followComedian")
  ) {
    url.searchParams.delete("payment_intent_id");
    url.searchParams.delete("followComedian");
    window.history.replaceState({}, document.title, url.toString());
  }

  if (setLocalPaymentIntentId) {
    setLocalPaymentIntentId(null);
  }
};
